import React, { useState, useEffect } from "react";

import { __ } from "services/Translator";
import api from "services/api";
import { Modal } from "react-bootstrap";
import { isMobile } from "services/isMobile";
import { Link } from "react-router-dom";

export default function FiatWithdrawals(props) {
  const isAuthenticated = props.isAuthenticated;
  const userDetails = props.userDetails;
  const userBalance = props.userBalance;

  const [showWalletAddressInput, setShowWalletAddressInput] = useState(false);
  const [showPhoneInput, setShowPhoneInput] = useState(false);
  const [showEmailAddress, setShowEmailAddress] = useState(false);
  const [paymentSystem, setPaymentSystem] = useState("");
  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [withdrawalWallet, setWithdrawalWallet] = useState("");
  const [withdrawalEmail, setWithdrawalEmail] = useState("");
  const [withdrawalPhone, setWithdrawalPhone] = useState("");
  const [withdrawalMethods, setWithdrawalMethods] = useState([]);
  const [withdrawalMethod, setWithdrawalMethod] = useState(null);
  const [withdrawalDetails, setWithdrawalDetails] = useState({});
  const [withdrawalConfirmationModal, setWithdrawalConfirmationModal] =
    useState(false);
  const [withdrawalError, setWithdrawalError] = useState(null);

  const [withdrawalOption, setWithdrawalOption] = useState("");

  const getWithdrawalMethods = async () => {
    // if (withdrawalAmount) {
    props.setSpinner(true);
    var response = await api.post("/withdraw/methods", {
      amount: withdrawalAmount,
    });
    props.setSpinner(false);
    if (response.status === 200) {
      const filteredUsers = response.data.methods.filter(
        (method) => !method.method_id.includes("COINSPAID")
      );
      setWithdrawalMethods(filteredUsers);

      // setWithdrawalMethods(response.data.methods);
      if (
        !response.data.methods.filter(
          (method) => method.method_id === withdrawalMethod
        ).length
      ) {
        setWithdrawalMethod(null);
      }
      setWithdrawalDetails(response.data.details);
    }
    // }
  };

  const isWithdrawPossible = async () => {
    if (!withdrawalMethod) {
      setWithdrawalError(__("Please select a withdrwal method"));
    } else if (!withdrawalWallet && isWalletAddressRequired()) {
      setWithdrawalError(__("Please enter your wallet address"));
    } else {
      var response = await api.post("/is-withdraw-possible", {
        method: withdrawalMethod,
        accNumber: withdrawalWallet,
      });
      if (response.status === 200) {
        setWithdrawalError(null);
      } else {
        setWithdrawalError(response.data.message);
      }
    }
  };

  const isWithdrawPossibleDirect = async () => {
    if (!withdrawalMethod) {
      setWithdrawalError(__("Please select a withdrwal method"));
    } else {
      // var response = await api.post("/is-withdraw-possible", {
      //   method: withdrawalMethod,
      //   accNumber: withdrawalWallet,
      // });
      // if (response.status === 200) {
      //   setWithdrawalError(null);
      // } else {
      //   setWithdrawalError(response.data.message);
      // }
      setWithdrawalConfirmationModal(true);
    }
  };

  const showWithdrwalConfirmationDirect = (event) => {
    event.preventDefault();
    setWithdrawalError("");
    isWithdrawPossibleDirect();
  };

  const showWithdrwalConfirmation = (event) => {
    event.preventDefault();
    isWithdrawPossible();
    setWithdrawalConfirmationModal(true);
  };
  const closeWithdrwalConfirmation = () => {
    setWithdrawalConfirmationModal(false);
  };

  const submitWithdraw = async () => {
    if (withdrawalError) {
      return;
    }
    props.setSpinner(true);
    var response = await api.post("/withdraw", {
      amount: withdrawalAmount,
      method: withdrawalMethod,
      accNumber: withdrawalWallet,
      email: withdrawalEmail,
      phoneNumber: withdrawalPhone,
    });
    props.setSpinner(false);
    if (response.status === 200) {
      if (response.data.status === "success") {
        props.showAlert("Success!!", response.data.message);
        setWithdrawalAmount("");
        setWithdrawalMethod(null);
        setWithdrawalWallet("");
        getWithdrawalMethods();
        closeWithdrwalConfirmation();
        props.getUserBalance();
      }
    } else {
      props.showAlert(null, response.data.message);
    }
  };

  const checkInputField = (method) => {
    const isShowWallet = isWalletAddressRequired(method);
    setShowWalletAddressInput(isShowWallet);
    if (method == "Interac") {
      setShowPhoneInput(true);
      setShowEmailAddress(true);
    }
    return;
  };

  const isWalletAddressRequired = (method) => {
    var required = false;
    if (!method) {
      required = true;
    } else if (method === "SKRILL:WLT") {
      required = true;
    } else if (method.indexOf("CRYPTOPAY:") === 0) {
      required = true;
    } else if (method == "Interac") {
      required = false;
    } else if (method.indexOf("Counos:") === 0) {
      required = true;
    } else if (method.indexOf("COINSPAID:") === 0) {
      required = true;
    } else if (method.indexOf("WEBPAYMENT:") === 0) {
      required = true;
    }
    return required;
  };

  useEffect(() => {
    getWithdrawalMethods();
    // }, [withdrawalOption]);
  }, [withdrawalAmount, withdrawalOption]);

  return (
    <>
      {/* <UserLeftArea section="Withdraw" /> */}
      <div className="right_area white">
        <p className="text">
          {__("Use the form below to withdraw funds from your account.")}
        </p>
        {__("Amount that can be withdrawn:")}{" "}
        <b>{withdrawalDetails.total_withdrawal_amount}</b> USD
        <p className="text">
          {__("Total locked bonus amount:")}{" "}
          <b>{withdrawalDetails.locked_bonus_amount}</b> USD
          {__("Total bet turnover:")} <b>{withdrawalDetails.bet_turnover}</b>{" "}
          USD
          {__("Total bet amount necessary to unlock remaining bonus:")}{" "}
          <b>{withdrawalDetails.amount_2_unlock}</b> USD &nbsp; &nbsp;
        </p>
        <p>
          {__("Choose payment system")}
          &nbsp;
          <i>
            {__(
              "*you can make a withdrawal only by using payment system you made deposit before"
            )}
          </i>
          &nbsp;
        </p>
        {withdrawalMethod == "Interac" && (
          <div class="alert alert-warning">
            <b>{__("Withdraw money easily with INTERAC e-Transfer:")}</b>
            <ul>
              <li>
                {__(
                  "The recipient will receive an SMS text message with his/her security question answer on the mobile number supplied."
                )}
              </li>
              <li>
                {__(
                  "An INTERAC e-Transfer email will be sent to the email address supplied."
                )}
              </li>
              <li>
                {__(
                  "The End-user copies “Recipient email” and “Message”, enter the amount."
                )}
              </li>
              <li>
                {__(
                  "The recipient will receive 3 reminders until he accepts or declines the INTERAC e-Transfer."
                )}
              </li>
            </ul>
          </div>
        )}
        <p>{__("Choose Coin")}</p>
        <form method="post">
          <div className="row">
            <div className="col-12 deposit-methods">
              <div className="payment_method_list">
                <div className="banking_area">
                  <div className="banking_list_area">
                    {/* <div className="small_info">
                        {__(
                          "Click on the 'i' icon within a logo for more information about a payment method."
                        )}
                      </div> */}

                    {withdrawalMethods.map((method, index) => (
                      <div className="single_banking e_wallet_method">
                        <input
                          id={"all_" + method.id}
                          onChange={() => {
                            setWithdrawalMethod(method.method_id);
                            checkInputField(method.method_id);
                          }}
                          type="radio"
                          className={props.landingType}
                          checked={method.method_id === withdrawalMethod}
                          value={method.method_id}
                        />
                        <label htmlFor={"all_" + method.id}>
                          <ul>
                            <li className="payment_logo_area">
                              {/* <a
                                  target="_blank"
                                  href="https://www.counos.io/CounosX"
                                  className="icon_popover"
                                >
                                  i
                                </a> */}
                              <span className="helper"></span>
                              <span className="payment_text_mobile">
                                <span className="helper"></span>
                                <span className="method_logo_text">
                                  {__("Method Logo")}
                                </span>
                              </span>
                              <div
                                className="method_logo"
                                style={{
                                  backgroundImage: "url(" + method.logo + ")",
                                }}
                              ></div>
                              <div className="clearfix"></div>
                            </li>
                            <li className="payment_method_name">
                              <span className="helper"></span>
                              <span className="payment_text_mobile">
                                {__("Method Name")}
                              </span>
                              <span className="payment_content">
                                {" "}
                                {method.method}
                              </span>
                              <div className="clearfix"></div>
                            </li>
                            <li className="min_payment_amount">
                              <span className="payment_text_mobile">
                                {__("Limit Amount")}
                              </span>
                              <span className="payment_content">
                                {__("MIN")} {method.min_withdrawal} USD
                                <i>
                                  **{method.withdrawal_fee}%{" "}
                                  {__(
                                    "Transaction fee will be deducted from your withdrawal amount."
                                  )}
                                </i>
                              </span>
                              <div className="clearfix"></div>
                            </li>
                          </ul>
                        </label>
                        <label
                          htmlFor={"all_" + method.id}
                          className="payment_check_mark"
                        >
                          <i className="fas fa-check selected_method_icon"></i>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <input
                type="number"
                value={withdrawalAmount}
                onChange={(ev) => setWithdrawalAmount(ev.target.value)}
                className="input_box  margin_bottom_30 border_bottom"
                placeholder={__("Amount")}
              />
            </div>
            {showWalletAddressInput && (
              <div className="col-sm-12 account_number">
                <input
                  type="text"
                  className="input_box  border_bottom email_address margin_bottom_30"
                  placeholder={__("Wallet Address")}
                  value={withdrawalWallet}
                  onChange={(ev) => setWithdrawalWallet(ev.target.value)}
                />
              </div>
            )}

            {/* <div className="col-sm-12">
              <input
                type="text"
                value={paymentSystem}
                onChange={(ev) => setPaymentSystem(ev.target.value)}
                className="input_box  border_bottom margin_bottom_30"
                placeholder={__(" Enter payment system")}
              />
            </div> */}
            {showEmailAddress && (
              <div className="col-sm-12 account_number">
                <input
                  type="email"
                  value={withdrawalEmail}
                  onChange={(ev) => setWithdrawalEmail(ev.target.value)}
                  className="input_box  border_bottom email_address margin_bottom_30"
                  placeholder={__("Email Address")}
                />
              </div>
            )}
            {showPhoneInput && (
              <div className="col-sm-12 account_number">
                <input
                  type="number"
                  value={withdrawalPhone}
                  onChange={(ev) => setWithdrawalPhone(ev.target.value)}
                  className="input_box  border_bottom email_address margin_bottom_30"
                  placeholder={__("Phone")}
                />
              </div>
            )}
          </div>
          <div className="button_group">
            <Link
              onClick={showWithdrwalConfirmationDirect}
              className={"angle_btn " + props.landingType}
            >
              {__("Submit withdrawal")}
            </Link>
          </div>
        </form>
      </div>

      <Modal
        show={withdrawalConfirmationModal}
        onHide={closeWithdrwalConfirmation}
        id="popup-withdraw"
        className="main_popup"
        centered
      >
        <Modal.Body>
          <>
            <div
              onClick={closeWithdrwalConfirmation}
              className="close_button text-end"
              closeButton
            >
              <i className="far fa-times"></i>
            </div>

            <div className="text-white">
              {withdrawalError ? (
                <p>{withdrawalError}</p>
              ) : (
                <p className="padding_top_bottom_30">
                  {__(
                    "Are you sure you want to make a withdrawal? Any remaining Bonus Balance or Free Spins will be forfeited."
                  )}{" "}
                </p>
              )}
            </div>

            <div className="button_group d-flex justify-content-between">
              {!withdrawalError && (
                <button
                  type="button"
                  className={"angle_btn small " + props.landingType}
                  onClick={submitWithdraw}
                >
                  {__("confirm")}
                </button>
              )}
              <button
                type="button"
                className={"angle_btn small " + props.landingType}
                onClick={closeWithdrwalConfirmation}
              >
                {__("Close")}
              </button>
            </div>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
}
